import React, { useState } from "react";
import { Link } from "react-router-dom";
import ModalVideo from "react-modal-video";
import "react-modal-video/css/modal-video.min.css"; // Importa el CSS necesario para el modal
import styles from "./Comoutilizar.module.css";
import axios from "axios";
import { useEffect } from "react";
import { getVideoUrl, getVideoThumbnailUrl } from "../../../utils/imageUtils";
import { Popup } from "../PopUp/Popup";

export const ComoUtilizarProductos = () => {
  const [isOpen, setOpen] = useState(false);
  const [currentVideo, setCurrentVideo] = useState("");
  const [videos, setVideos] = useState([]);
  const [isDriveModalOpen, setIsDriveModalOpen] = useState(false);

  const getVideos = async () => {
    try {
      let response = await axios.get(`${process.env.REACT_APP_API_URL}/api/tutoriales`)
      console.log("videos", response.data)
      // Usar los tutoriales del API
      if (response.data && response.data.tutoriales) {
        setVideos(response.data.tutoriales);
      }
    } catch (error) {
      console.error("Error al obtener videos:", error);
    }
  }

  useEffect(() => {
    getVideos()
  }, [])

  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" }); // Desplaza suavemente hacia arriba
  };

  const openModal = (videoUrl) => {
    const fullVideoUrl = getVideoUrl(videoUrl);
    if (fullVideoUrl.includes("drive.google.com")) {
      setCurrentVideo(fullVideoUrl);
      setIsDriveModalOpen(true);
    } else {
      setCurrentVideo(fullVideoUrl);
      setOpen(true);
    }
  };

  const getVideoModalProps = (videoUrl) => {
    if (videoUrl.includes('youtube.com') || videoUrl.includes('youtu.be')) {
      // Para videos de YouTube
      const videoId = videoUrl.includes('watch?v=') 
        ? videoUrl.split('watch?v=')[1].split('&')[0]
        : videoUrl.split('youtu.be/')[1].split('?')[0];
      return {
        channel: 'youtube',
        videoId: videoId
      };
    } else {
      // Para videos MP4 u otros formatos
      return {
        channel: 'custom',
        url: videoUrl
      };
    }
  };

  return (
    <>
      <h2 className={styles.titulo}>Conoce cómo utilizar nuestros productos</h2>
      <div className={styles.contenedorBtn}>
        <Link className={styles.btn} onClick={handleScrollToTop} to={"/videos"}>
          Ver todos los videos
        </Link>
      </div>
      <ModalVideo
        {...getVideoModalProps(currentVideo)}
        autoplay
        isOpen={isOpen}
        onClose={() => setOpen(false)}
      />
      {isDriveModalOpen && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          background: 'rgba(0,0,0,0.7)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999
        }}>
          <div style={{ position: 'relative', background: '#fff', borderRadius: '10px', padding: '20px' }}>
            <button onClick={() => setIsDriveModalOpen(false)} style={{ position: 'absolute', top: 10, right: 10, fontSize: 24, background: 'none', border: 'none', cursor: 'pointer' }}>×</button>
            <iframe
              src={getDriveEmbedUrl(currentVideo)}
              width="640"
              height="360"
              allow="autoplay"
              allowFullScreen
              style={{ border: 'none', borderRadius: '10px' }}
              title="Google Drive Video"
            />
          </div>
        </div>
      )}
      <div className={styles.contenedor}>
        {videos.slice(0, 3).map((video) => (
          <div
            key={video._id}
            className={styles.contenedorVideo}
            onClick={() => openModal(video.urlVideo)}
          >
            <img
              src={getVideoThumbnailUrl(video.imageMiniatura)}
              alt={video.title}
              style={{
                width: "320px",
                height: "240px",
                borderRadius: "20px",
                objectFit: 'cover'
              }}
            />
            <h2 className={styles.tituloVideo}>{video.title}</h2>
          </div>
        ))}
      </div>
    </>
  );
};

// Helper para obtener el embed url de Google Drive
function getDriveEmbedUrl(url) {
  // Extrae el ID del archivo de Google Drive
  const match = url.match(/\/file\/d\/([\w-]+)/);
  if (match && match[1]) {
    return `https://drive.google.com/file/d/${match[1]}/preview`;
  }
  // Si ya es un preview o no se puede extraer, retorna el mismo url
  if (url.includes('/preview')) return url;
  return url;
}
